import React from 'react';
import { Card, Badge, Button, Dropdown, Form } from 'react-bootstrap';
import { FaChartLine, FaSync, FaChevronDown, FaChevronUp, FaCalendarAlt } from "react-icons/fa";

const DashboardHeader = ({
  timeRangeType,
  loadingMetrics,
  isCollapsed,
  fetchHealthMetrics,
  setIsCollapsed,
  calculateDateRange
}) => {

  const currentRange = calculateDateRange(timeRangeType);

  return (
    <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <FaChartLine className="me-2" />
        <div>
          <strong>Health Metrics Dashboard</strong>
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        <Button
          variant="outline-light"
          size="sm"
          className="me-2"
          onClick={() => fetchHealthMetrics(currentRange)}
          disabled={loadingMetrics}
          title="Refresh Data"
        >
          <FaSync size={12} />
        </Button>
        <Button
          variant="outline-light"
          size="sm"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          {isCollapsed ? <FaChevronDown size={12} /> : <FaChevronUp size={12} />}
        </Button>
      </div>
    </Card.Header>
  );
};

export default DashboardHeader;